<app-loader *ngIf="(userNoteLoading$ | async) === true"></app-loader>

<div *ngIf="(userNoteLoading$ | async) === false && notes$.length !== 0">
  <form (ngSubmit)="editNoteAboutStudent()">
    <mat-dialog-content>
      <div *ngFor="let note of notes$">
        <h5 class="mt-0 mb-3">Заметка о студенте {{ student?.full_name }}</h5>
        <p>{{ notes$[0].text }}</p>
        <p class="text-right">
          - <i>{{ notes$[0].writer.full_name }}</i>
        </p>
      </div>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        label="Редактировать"></app-button-with-progress>
    </div>
  </form>
</div>

<div *ngIf="(userNoteLoading$ | async) === false && notes$.length === 0">
  <form (ngSubmit)="openAddNoteModal()">
    <mat-dialog-content>
      <p>
        Вы не оставляли ни одной записи перед ESDP о
        <strong>{{ student?.full_name }}</strong>
      </p>
      <p>Хотите оставить заметку?</p>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        label="Добавить"></app-button-with-progress>
    </div>
  </form>
</div>
